import { useFeatureFlag } from '../../context/FeatureFlagContext';
import { getBinancePayBlockchainData } from '../CurrencySelection/utils';
import { Currency } from '../CurrencySelection/CurrencySelection';

export const useBinancePay = (currencies: Currency[]) => {
  const { featureFlags } = useFeatureFlag();

  const binancePayBlockchainData = getBinancePayBlockchainData(
    currencies || []
  );
  const isBinancePayDisabled = !binancePayBlockchainData?.available;
  const binanceDisableReason = binancePayBlockchainData?.reason;
  const isBinancePayEnabled = Boolean(
    featureFlags.binancePay && !isBinancePayDisabled
  );

  const getBinancePayHelperMessage = () => {
    if (!featureFlags.binancePay || isBinancePayDisabled) {
      return binanceDisableReason || 'Temporarily unavailable';
    }
    return '';
  };

  return {
    isBinancePayEnabled,
    binanceDisableReason,
    getBinancePayHelperMessage,
  };
};
